import React, { useState, createContext } from 'react'
import themeConfig from '../../config/themeConfig'
import primaryColorConfig from '../../config/primaryColorConfig'
import { useObjectCookie } from '../../hooks/useObjectCookie'

export const SettingsContext = createContext(null)

export const SettingsProvider = (props) => {

    const initialSettings = {
        mode: themeConfig.mode,
        systemMode: themeConfig.mode == 'system' ? 'light' : themeConfig.mode,
        primaryColor: primaryColorConfig[0].main,
        skin: themeConfig.skin,
        isDrawerOpen: false,
        drawer: 'permanent',
        isLoading: false,
    }

    // Cookies
    const [settingsCookie, updateSettingsCookie] = useObjectCookie(
        themeConfig.settingsCookieName,
        initialSettings
    )

    // State
    const [_settingsState, _updateSettingsState] = useState(
        JSON.stringify(settingsCookie) !== '{}' ? settingsCookie : initialSettings
    );

    const updateSettings = (settings, persist = true) => {
        _updateSettingsState(prev => {
            const newSetting = { ...prev, ...settings }
            if (persist) {
                updateSettingsCookie(newSetting);
            }
            return newSetting;
        })
    }

    return (
        <SettingsContext.Provider
            value={{
                settings: _settingsState,
                updateSettings
            }}
        >
            {props.children}
        </SettingsContext.Provider>
    )


}